const apiUrl = "https://swipcar.wpengine.com/wp-json/wp/v2/"

export async function getBlogPosts(country, tag) {
  const normalizedTag = String(tag || "").trim()
  if (!normalizedTag) return []

  const tagId = /^\d+$/.test(normalizedTag) ? normalizedTag : await getBlogTagId(country, normalizedTag)
  if (!tagId) return []

  return fetchPosts(`${apiUrl}posts?_embed&lang=${encodeURIComponent(country)}&tags=${encodeURIComponent(tagId)}`)
}

export function getReviews(country, slugs = []) {
  if (!slugs.length) return []

  const slugQuery = slugs.map(slug => encodeURIComponent(slug)).join("&slug[]=")

  return fetchPosts(`${apiUrl}opinions?_embed&lang=${encodeURIComponent(country)}&slug[]=${slugQuery}`)
}

async function getBlogTagId(country, tag) {
  const tags = await fetchJsonArray(`${apiUrl}tags?lang=${encodeURIComponent(country)}&slug=${encodeURIComponent(tag)}`)
  const tagId = tags[0]?.id

  return tagId ? String(tagId) : null
}

async function fetchPosts(url) {
  const posts = await fetchJsonArray(url)

  posts.forEach(post => {
    /* eslint-disable no-param-reassign */
    /* eslint-disable no-underscore-dangle */
    delete post.content
    if (post._embedded) {
      delete post._embedded["wp:term"]
      delete post._embedded.author
    }
    delete post.yst_prominent_words
    delete post._links
    delete post.meta
    /* eslint-enable no-param-reassign */
    /* eslint-enable no-underscore-dangle */
  })

  return posts
}

async function fetchJsonArray(url) {
  try {
    const res = await fetch(url)
    if (!res.ok) return []

    const parsedResponse = await res.json()
    return Array.isArray(parsedResponse) ? parsedResponse : []
  } catch (exception) {
    return []
  }
}
